import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { AnalyzerDish } from 'types';

export const getDishFeedsByAnalyzer = async (
  analyzerId: number
): Promise<AnalyzerDish[]> => {
  if (analyzerId < 1) return [];
  const { data } = await axios.get(`/api/dishes/analyzers/${analyzerId}/feeds`);
  return data as AnalyzerDish[];
};

type QueryFnType = typeof getDishFeedsByAnalyzer;

type UseDishesByAnalyzerOptions = {
  analyzerId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDishFeedsByAnalyzer = ({
  analyzerId,
  config,
}: UseDishesByAnalyzerOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['dishes', 'analyzers', analyzerId, 'feeds'],
    queryFn: () => getDishFeedsByAnalyzer(analyzerId),
    ...config,
  });
};
